<script lang="ts">
  import type { EntityParameterType } from '$shared/constants/EntityParameterType';

  interface Props {
    value: any;
    type: EntityParameterType;
    disabled?: boolean;
    name?: string;
    onadd?: (param: EntityParameterType) => void;
    onevent?: (payload: any) => void;
  }

  let {
    value,
    type,
    disabled = false,
    name = '',
    onadd,
    onevent
  }: Props = $props();

  const onClickAdd = (param: EntityParameterType): void => {
    onadd?.(param);
  };
</script>

<div data-cy={`${name}-value-comp`} class="comp-input-value">
  {#if value}
    {#if value.component}
      <value.component {...value.props} {onevent} />
    {:else}
      <div data-cy={`${name}-v`} class="text">{value}</div>
    {/if}
  {:else}
    <button
      data-cy={`${name}-add-action`}
      class="add-btn"
      type="button"
      {disabled}
      onclick={() => onClickAdd(type)}>Add</button
    >
  {/if}
</div>

<style>
  .comp-input-value {
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: var(--grey-dark);
  }
  .add-btn {
    color: var(--blue);
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 4px;
  }
  .add-btn:disabled {
    color: var(--grey-dark);
    cursor: not-allowed;
  }
</style>
